import React from "react"
import CodeBlock from "./CodeBlock"
import Figure from "./Figure"
import Card, { Cards } from "./Card"
import GridGallery from "./GridGallery"
import { GradientText } from "../Common"
import SvgDiagram from "./SvgDiagram"
import ResponsiveVideo from "./ResponsiveVideo"
import GrandQuote from "./GrandQuote"
import CustomImage from "./CustomImage"
import DefineTerm from "./DefineTerm"

export const mdxComponents = {
  code: CodeBlock,
  Figure,
  img: props => (
    <img
      {...props}
      style={
        props.src.split(".")[1] === "gif"
          ? {
              maxWidth: "100%",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }
          : { borderRadius: "1rem", backgroundColor: "var(--color-background-base)", ...props.style }
      }
      alt={props.alt}
    />
  ),
  Cards,
  Card,
  GridGallery,
  GradientText,
  SvgDiagram,
  ResponsiveVideo,
  GrandQuote,
  CustomImage,
  DefineTerm,
  // p: props => {
  //   console.log(props.children)
  //   return (
  //     <p
  //       style={
  //         typeof props.children !== "object"
  //           ? { marginTop: "calc(var(--safety-padding) / 3)" }
  //           : {}
  //       }
  //     >
  //       {props.children}
  //     </p>
  //   )
  // },
}
